// This file is auto-generated by @hey-api/openapi-ts

/**
 * Channel the coupon was purchased through. Unset for coupons not tied to an order.
 */
export const TicketFareSourceEnum = {
    ESHOP: 'ESHOP',
    MOBILE: 'MOBILE',
    COUNTER: 'COUNTER',
    KIOSK: 'KIOSK'
} as const;

/**
 * Channel the coupon was purchased through. Unset for coupons not tied to an order.
 */
export type TicketFareSourceEnum = typeof TicketFareSourceEnum[keyof typeof TicketFareSourceEnum];
